import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import "bootstrap/dist/css/bootstrap.min.css";
import App from './App';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const options = {
    mode: 'setup',
    paymentMethodCreation: 'manual',
    currency: 'usd',
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Elements stripe={stripePromise} options={options} >
            <App />
        </Elements>
    </React.StrictMode>
);
